import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import { Button, Input } from "components/bootstrap";
import { FormikFormGroup, Select } from "components/common";
const AUTH_OPTIONS = [
  { value: "automatic", label: "Automatic" },
  { value: "account_key", label: "Account key" }
];
export const validateAzureCredentialsForm = (values) => {
  var _a;
  const errors = {};
  if (!values.auth_mode) {
    errors.auth_mode = "Required.";
  }
  if (!((_a = values.account_name) == null ? void 0 : _a.trim())) {
    errors.account_name = "Required.";
  }
  if (values.auth_mode === "account_key" && (!values.account_key || "delete_value" in values.account_key)) {
    errors.account_key = "Required when using Account key authentication.";
  }
  return errors;
};
const AzureCredentialsFormFields = ({ keyIsSet }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [showResetButton, setShowResetButton] = useState(keyIsSet);
  const keyError = errors.account_key;
  const setKey = (key) => setFieldValue("account_key", key);
  const toggleKeyReset = () => {
    if (showResetButton) {
      setKey({ delete_value: true });
      setShowResetButton(false);
    } else {
      setKey({ keep_value: true });
      setShowResetButton(true);
    }
  };
  const handleAuthModeChange = (authMode) => {
    if (authMode === values.auth_mode) {
      return;
    }
    if (authMode === "automatic") {
      setKey(void 0);
      setShowResetButton(false);
    } else {
      setKey(keyIsSet ? { keep_value: true } : void 0);
      setShowResetButton(keyIsSet);
    }
    setFieldValue("auth_mode", authMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "account_name",
      type: "text",
      label: "Account Name",
      placeholder: "your-account-name",
      help: "The name of your Azure storage account.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "endpoint_uri",
      type: "text",
      label: "Endpoint URL (optional)",
      help: "Only required if you want to override the default Azure Blob endpoint.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-auth-mode",
      label: "Authentication Type",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "credentialsAuthMode",
        name: "auth_mode",
        placeholder: "Select Authentication Type",
        "aria-label": "Select authentication type",
        options: AUTH_OPTIONS,
        onChange: handleAuthModeChange,
        clearable: false,
        value: values.auth_mode
      }
    )
  ), values.auth_mode === "account_key" && (showResetButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-account-key-reset",
      label: "Account Key",
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleKeyReset }, "Reset key")
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-account-key",
      type: "password",
      label: "Account Key",
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      onChange: ({ target: { value } }) => setKey(value === "" ? { delete_value: true } : { set_value: value }),
      buttonAfter: keyIsSet ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleKeyReset }, "Undo Reset") : void 0,
      placeholder: "****************",
      help: "The access key of the storage account.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  )));
};
export default AzureCredentialsFormFields;
